'use client';
import useImageSizes from 'helpers/hooks/useImageSizes';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import { mobile } from 'helpers/utils/screensizes';
import HeroContentBlock from './components/hero-content-block';
import { BannerTileProps } from './types';
import Image from '../../atoms/image';

export default function BannerTile({
  backgroundImage,
  contentBlock,
  keyInfo,
  onCtaClick,
  aspectRatioDesktop,
  aspectRatioMobile,
}: Readonly<BannerTileProps>) {
  const [isDesktopSize] = useMediaQuery(mobile);

  const sizes = useImageSizes({
    sm: 0.3,
    md: 0.3,
    lg: 0.6,
    defaultSize: 0.6,
    maxWidth: 1128,
  });
  return (
    <article
      id="banner-tile-container"
      className="relative max-h-[410px] w-full overflow-hidden rounded-xl sm:max-h-[482px] sm:rounded-2xl"
      aria-label="Banner slide"
      data-ffid={`pnl-banner-tile-${keyInfo}`}
    >
      {backgroundImage?.bgImageSrc && (
        <div
          id="banner-tile-background-image"
          className="relative max-h-[410px] w-full overflow-hidden rounded-xl sm:max-h-[482px] sm:rounded-2xl"
          style={{
            aspectRatio: isDesktopSize ? aspectRatioDesktop : aspectRatioMobile,
          }}
        >
          <Image
            data-ffid={`img-herobanner-${keyInfo}`}
            src={backgroundImage.bgImageSrc}
            alt={backgroundImage.bgImageAlt || 'Background image'}
            className="size-full rounded-xl object-cover sm:rounded-2xl"
            fill
            sizes={sizes}
            priority={keyInfo === 0}
            loading={keyInfo === 0 ? 'eager' : 'lazy'}
            fetchPriority={keyInfo === 0 ? 'high' : 'auto'}
            unoptimized={false}
          />
        </div>
      )}

      {isDesktopSize && (
        <HeroContentBlock
          contentBlock={contentBlock}
          isDesktopSize={isDesktopSize}
          keyInfo={keyInfo}
          onCtaClick={onCtaClick}
        />
      )}
    </article>
  );
}
